<div *ngIf="!loading && profile.walletstatus === 0 && hasToCategorizeOrAcceptMpConsents === null && !showPhoneStep"
  class="general-container flex flex-col md:flex-row justify-center items-center md:items-start gap-32">
  <div class="header flex flex-col divide-y divide-gray-10 gap-12 w-full md:w-[38%] md:flex-shrink-0 p-20 rounded-xl bg-gray-10/[0.1] md:sticky md:top-20">
    <div class="titleContainer pb-16">
      <h2 class="font-sans text-eggplant-100 text-xl pb-16">{{ 'MOVEMENTS.DEPOSIT-FUNDS.HOW-DEPOSIT' | translate }}</h2>
      <p class="font-sans text-eggplant-100 text-l">{{ 'MOVEMENTS.DEPOSIT-FUNDS.WAY-DEPOSIT' | translate }}</p>
    </div>
    <div class="notice flex items-start gap-8 px-16 py-12 mb-16 rounded-xl bg-orange-100/15 border border-orange-100/30">
      <fun-icon [name]="'alert-triangle'" [style]="'w-20 h-20 stroke-[2px] stroke-orange-100 flex-shrink-0 mt-1'"></fun-icon>
      <p class="font-sans text-s text-orange-100 text-left">{{ 'MOVEMENTS.DEPOSIT-FUNDS.IMPORTANT-NOTICE' | translate }}</p>
    </div>
    <div class="advice flex gap-12 pt-20">
      <fun-icon [name]="'info-circle'" [style]="'w-24 h-24 stroke-gray-40 stroke-2'"></fun-icon>
      <p class="font-sans text-eggplant-100/[0.4] text-m">{{ 'MOVEMENTS.DEPOSIT-FUNDS.IN-ADDITION' | translate }}</p>
    </div>
  </div>
  <div class="content px-0 pt-0 pb-32 md:px-20 md:pt-20 md:pb-20 md:flex-1 md:min-w-0">
    <h2 class="font-sans text-eggplant-100 text-xl pb-16">{{ 'MOVEMENTS.DEPOSIT-FUNDS.BANK-TRANSFER' | translate }}</h2>
    <p class="font-sans text-eggplant-100/[0.6] text-m pb-16">{{ 'MOVEMENTS.DEPOSIT-FUNDS.BANK-TRANSFER-SUBTITLE' | translate }}</p>
    <div class="flex flex-col">

      <div class="flex flex-col w-full pt-0 pb-12 justify-between relative">
        <div class="absolute bg-gray-10 w-[3px] h-full top-[4px] left-[14px] z-[1]"></div>
        <div>
          <header class="flex flex-row items-start gap-12">
            <div class="flex items-center">
              <span
                class="flex justify-center items-center content-center w-32 h-32 rounded-full border-4 border-white bg-orange-100 z-[10]">
                <span class="flex justify-center items-center content-center font-sans text-white">1</span>
              </span>
            </div>
            <div class="flex flex-col pt-2">
              <h4 class="flex flex-row gap-x-12 font-sans text-l text-eggplant-100">
                {{ 'MOVEMENTS.DEPOSIT-FUNDS.ENTER-BANK' | translate }}
              </h4>
              <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'MOVEMENTS.DEPOSIT-FUNDS.BANK-ACCOUNT' | translate
                }}</p>
            </div>
          </header>
        </div>
      </div>

      <div class="flex flex-col w-full pt-0 pb-12 justify-between relative">
        <div class="absolute bg-gray-10 w-[3px] h-full top-[4px] left-[14px] z-[1]"></div>
        <div>
          <header class="flex flex-row items-start gap-12">
            <div class="flex items-center">
              <span
                class="flex justify-center items-center content-center w-32 h-32 rounded-full border-4 border-white bg-orange-100 z-[10]">
                <span class="flex justify-center items-center content-center font-sans text-white">2</span>
              </span>
            </div>
            <div class="flex flex-col pt-2">
              <h4 class="flex flex-row gap-x-12 font-sans text-l text-eggplant-100">
                {{ 'MOVEMENTS.DEPOSIT-FUNDS.CONFIGURE-TRANSFER' | translate }}
              </h4>
              <p class="font-sans text-m text-eggplant-100/[0.4] pt-4">{{
                'MOVEMENTS.DEPOSIT-FUNDS.CONFIGURE-TRANSFER-DESC' | translate }}</p>

              <details class="accountsScheme mt-12 rounded-xl border border-gray-10 px-16 py-12">
                <summary class="font-sans text-m text-eggplant-100 cursor-pointer select-none">
                  {{ 'MOVEMENTS.DEPOSIT-FUNDS.ACCOUNTS-SCHEME-TOGGLE' | translate }}
                </summary>
                <div class="flex flex-col items-stretch gap-8 pt-16">
                  <div class="accountCard rounded-lg bg-gray-10/[0.3] px-12 py-8">
                    <p class="font-sans text-s text-eggplant-100/[0.4]">{{
                      'MOVEMENTS.DEPOSIT-FUNDS.ORIGIN-ACCOUNT' | translate }}</p>
                    <p class="font-sans text-m text-eggplant-100">{{ 'MOVEMENTS.DEPOSIT-FUNDS.ORIGIN-ACCOUNT-DESC' |
                      translate }}</p>
                    <p class="font-sans text-s text-eggplant-100/[0.6]">{{ 'MOVEMENTS.DEPOSIT-FUNDS.HOLDER' | translate
                      }}: {{ addressee }}</p>
                  </div>
                  <div class="flex justify-center">
                    <fun-icon [name]="'arrow-down'" [style]="'w-20 h-20 stroke-2 stroke-eggplant-70'"></fun-icon>
                  </div>
                  <div class="accountCard rounded-lg bg-gray-10/[0.3] px-12 py-8">
                    <p class="font-sans text-s text-eggplant-100/[0.4]">{{
                      'MOVEMENTS.DEPOSIT-FUNDS.DESTINATION-ACCOUNT' | translate }}</p>
                    <p class="font-sans text-m text-eggplant-100">{{
                      'MOVEMENTS.DEPOSIT-FUNDS.DESTINATION-ACCOUNT-DESC' | translate }}</p>
                    <p class="font-sans text-s text-eggplant-100/[0.6]">{{ 'MOVEMENTS.DEPOSIT-FUNDS.HOLDER' | translate
                      }}: {{ addressee }}</p>
                  </div>
                  <p class="font-sans text-s text-eggplant-100/[0.4] pt-4">{{
                    'MOVEMENTS.DEPOSIT-FUNDS.ACCOUNTS-SCHEME-FOOTER' | translate }}</p>
                </div>
              </details>

              <div class="flex flex-col divide-y divide-gray-10 py-8">
                <div class="detailContainer relative py-4 px-8">
                  <h4 class="font-sans text-eggplant-100/[0.4] text-m">{{ 'MOVEMENTS.DEPOSIT-FUNDS.RECIVER' | translate
                    }}</h4>
                  <p class="font-sans text-eggplant-100 text-l">{{ addressee }}</p>
                  <p class="font-sans text-s text-eggplant-100/[0.4]">{{ 'MOVEMENTS.DEPOSIT-FUNDS.RECIVER-HINT' |
                    translate }}</p>
                  <div class="copy" title="Copiar">
                    <fun-icon (click)="copy(addressee)" [name]="'copy'"
                      [style]="'w-20 h-20 stroke-2 stroke-eggplant-70'"></fun-icon>
                  </div>
                </div>
                <div class="detailContainer relative py-4 px-8">
                  <h4 class="font-sans text-eggplant-100/[0.4] text-m">{{ 'MOVEMENTS.DEPOSIT-FUNDS.CODE' | translate }}
                  </h4>
                  <p class="font-sans text-eggplant-100 text-l break-all">{{ profile.mangopayBankingAliasBic }}</p>
                  <div class="copy" title="Copiar">
                    <fun-icon (click)="copy(profile.mangopayBankingAliasBic)" [name]="'copy'"
                      [style]="'w-20 h-20 stroke-2 stroke-eggplant-70'"></fun-icon>
                  </div>
                </div>
                <div class="detailContainer relative py-4 px-8">
                  <h4 class="font-sans text-eggplant-100/[0.4] text-m">IBAN</h4>
                  <p class="font-sans text-eggplant-100 text-l break-all">{{ profile.mangopayBankingAliasIban }}</p>
                  <div class="copy" title="Copiar">
                    <fun-icon (click)="copy(profile.mangopayBankingAliasIban)" [name]="'copy'"
                      [style]="'w-20 h-20 stroke-2 stroke-eggplant-70'"></fun-icon>
                  </div>
                </div>
                <div class="detailContainer relative py-4 px-8">
                  <h4 class="font-sans text-eggplant-100/[0.4] text-m">{{ 'MOVEMENTS.DEPOSIT-FUNDS.ORDERED' | translate
                    }}</h4>
                  <p class="font-sans text-eggplant-100 text-l">{{ 'MOVEMENTS.DEPOSIT-FUNDS.SENDER-TRANSFER' | translate
                    }}</p>
                  <p class="font-sans text-eggplant-100 text-l">{{ 'MOVEMENTS.DEPOSIT-FUNDS.SENDER-TRANSFER-JOINT' |
                    translate }}</p>
                </div>
              </div>
              <button class="copyAllBtn flex items-center gap-8 self-start mt-8 px-12 py-8 rounded-lg border border-gray-10"
                (click)="copyAll()">
                <fun-icon [name]="'copy'" [style]="'w-16 h-16 stroke-2 stroke-eggplant-70'"></fun-icon>
                <span class="font-sans text-m text-eggplant-100">{{ 'MOVEMENTS.DEPOSIT-FUNDS.COPY-ALL' | translate
                  }}</span>
              </button>
            </div>
          </header>
        </div>
      </div>

      <div class="flex flex-col w-full pt-0 pb-12 justify-between relative">
        <div class="absolute bg-gray-10 w-[3px] h-full top-[4px] left-[14px] z-[1]"></div>
        <div>
          <header class="flex flex-row items-start gap-12">
            <div class="flex items-center">
              <span
                class="flex justify-center items-center content-center w-32 h-32 rounded-full border-4 border-white bg-orange-100 z-[10]">
                <span class="flex justify-center items-center content-center font-sans text-white">3</span>
              </span>
            </div>
            <div class="flex flex-col pt-2">
              <h4 class="flex flex-row gap-x-12 font-sans text-l text-eggplant-100">
                {{ 'MOVEMENTS.DEPOSIT-FUNDS.MAKE-TRANSFER' | translate }}
              </h4>
              <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'MOVEMENTS.DEPOSIT-FUNDS.MAKE-TRANSFER-DESC' |
                translate }}</p>
            </div>
          </header>
        </div>
      </div>

      <div class="flex flex-col w-full pt-0 pb-12 justify-between relative">
        <div class="absolute bg-gray-10 w-[3px] h-full top-[4px] left-[14px] z-[1]"></div>
        <div>
          <header class="flex flex-row items-start gap-12">
            <div class="flex items-center">
              <span
                class="flex justify-center items-center content-center w-32 h-32 rounded-full border-4 border-white bg-orange-100 z-[10]">
                <span class="flex justify-center items-center content-center font-sans text-white">4</span>
              </span>
            </div>
            <div class="flex flex-col pt-2">
              <h4 class="flex flex-row gap-x-12 font-sans text-l text-eggplant-100">
                {{ 'MOVEMENTS.DEPOSIT-FUNDS.WAIT' | translate }}
              </h4>
              <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'MOVEMENTS.DEPOSIT-FUNDS.WAIT-DESC' | translate
                }}</p>
            </div>
          </header>
        </div>
      </div>

      <div class="flex flex-col w-full pt-0 pb-12 justify-between relative">
        <div>
          <header class="flex flex-row items-start gap-12">
            <div class="flex items-center">
              <span
                class="flex justify-center items-center content-center w-32 h-32 rounded-full border-4 border-white bg-orange-100 z-[10]">
                <span class="flex justify-center items-center content-center font-sans text-white">5</span>
              </span>
            </div>
            <div class="flex flex-col pt-2">
              <h4 class="flex flex-row gap-x-12 font-sans text-l text-eggplant-100">
                {{ 'MOVEMENTS.DEPOSIT-FUNDS.START-INVEST' | translate }}
              </h4>
            </div>
          </header>
        </div>
      </div>
    </div>

    <div class="helpBlock flex flex-col gap-12 mt-24 pt-20 border-t border-gray-10">
      <h4 class="font-sans text-l text-eggplant-100">{{ 'MOVEMENTS.DEPOSIT-FUNDS.HELP-TITLE' | translate }}</h4>
      <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'MOVEMENTS.DEPOSIT-FUNDS.HELP-DESC' | translate }}</p>
      <div class="flex flex-col md:flex-row gap-12">
        <button class="helpBtn flex items-center justify-center gap-8 px-16 py-8 rounded-lg border border-gray-10"
          (click)="contactByEmail()">
          <fun-icon [name]="'mail'" [style]="'w-16 h-16 stroke-2 stroke-eggplant-70'"></fun-icon>
          <span class="font-sans text-m text-eggplant-100">{{ 'MOVEMENTS.DEPOSIT-FUNDS.HELP-EMAIL' | translate
            }}</span>
        </button>
        <button class="helpBtn flex items-center justify-center gap-8 px-16 py-8 rounded-lg border border-gray-10"
          (click)="contactByWhatsapp()">
          <fun-icon [name]="'whatsapp'" [style]="'w-16 h-16 stroke-2 stroke-eggplant-70'"></fun-icon>
          <span class="font-sans text-m text-eggplant-100">{{ 'MOVEMENTS.DEPOSIT-FUNDS.HELP-WHATSAPP' | translate
            }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!loading && (profile.walletstatus === -1 || hasToCategorizeOrAcceptMpConsents !== null) && !showPhoneStep"
  class="general-container flex flex-col md:flex-row justify-center gap-32">
  <app-money-out-categorize [user]="user" [walletStatus]="profile.walletstatus" [isMoneyIn]="true"
    (continueEvent)="continue()"></app-money-out-categorize>
</div>
<div *ngIf="loading">
  <fun-spinner></fun-spinner>
</div>
<div *ngIf="showPhoneStep && !loading">
  <fun-overal-message [text]="noPhoneText" [image]="noPhoneImage" [btnList]="noPhoneBtnList"
    (btnEvent)="goToMyProfile()"></fun-overal-message>
</div>